var _ = require('underscore');
var $ = require('jquery');
var TorsoFormView = require('backbone-torso/modules/FormView');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var DemographicsDataBehavior = require('./../demographics/DemographicsDataBehavior');
var paymentDetailsAchTemplate = require('./paymentDetailsAch.hbs');
var applicationUtils = require('./../applicationUtils');

/**
 * The PaymentDetailsAchView is a form view that handles ach related actions.
 *
 * @class PaymentDetailsAchView
 * @extends Torso.View
 */
module.exports = TorsoFormView.extend({
  className: 'portal-container portal-container--expanded-fields',
  moduleName: 'achView',
  template: paymentDetailsAchTemplate,

  behaviors: {
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: '_patientVecnaId' }
    }
  },

  prepareFields:{
    storedPmtEnabledOnCurrentApp: function() {
      return financialFeatureConfigModel.storedPmtEnabledOnCurrentApp();
    }
  },

  /**
   * View State flag to determine whether the user is storing this payment method
   * @property viewState.isStoredPayment
   * @type boolean
   */

  /**
   * @property viewState.accountNumberLast4 {String} the last four numbers on the account number. It is
   * replaced everytime the user hits review payment
   */

  /**
   * Configures feedback bindings.
   * @property feedback {Array of When/Then Feedbacks}
   */
  feedback: [{
    //******** Account Holder Name *********
    /**
     * On keyup or blur on the account holder name, validate the account holder name and add the error
     * message if needed
     * @property feedback[0] (Account Name Error Message) {When/Then Feedback}
     */
    when: {
      '@accountOwnerName' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        var errors = this.model.preValidate('accountOwnerName');
        var errorText = this._thenFormatFeedback(errors, {
          'required.failed' : 'field.enter',
          'error.digits.only' : 'ach.accountHolder.name.digitsOnly',
          'error.length' : 'ach.accountHolder.name.length.incorrect'
        }, this.format('ach.contactInfo.name'));
        var errorClass = this._thenAddClassIfInvalid('accountOwnerName', 'brec-feedback--error');
        var errorTestAttribute = { attr: ['data-test-name-validation', 'false'] };
        if (errors) {
          errorTestAttribute = { attr: ['data-test-name-validation', errors.key] };
        }
        return _.extend(errorText, errorClass, errorTestAttribute);
      }
    },
    to: 'accountOwnerNameError'
  },
  /**
   * On keyup or blur on the account holder name, validate the card name and add the error
   * class to needed elements
   * @property feedback[1] (Card name label) {When/Then Feedback}
   */
  {
    when: {
      '@accountOwnerName' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        return this._thenAddClassIfInvalid('accountOwnerName', 'brec-form__input--error');
      }
    },
    to: 'accountOwnerName'
  },
  {
  //******** Stored Payment Method Nickname *********
  /**
   * On keyup or blur on the stored payment method nickname or submits, validate the nickname and add the error
   * message if needed
   * @property feedback[0] (Nickname Error Message) {When/Then Feedback}
   */

    when: {
      '@storePayment.nickname' : ['keyup', 'blur'],
      '@storePayment.save': ['change'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        var nickname = $.trim(this.model.get('storePayment.nickname'));
        var errorText = this._thenFormatFeedback(this.model.preValidate('storePayment.nickname'), {
          'required.failed' : 'field.enter',
          'error.too.short' : 'ach.nickname.length.too.short',
          'error.too.long' : 'ach.nickname.length.too.long',
          'error.duplicate' : 'ach.nickname.duplicate'
        }, [ this.format('ach.nickname'), nickname ? nickname.length : 0 ]);
        var errorClass = this._thenAddClassIfInvalid('storePayment.nickname', 'brec-feedback--error');
        return _.extend(errorText, errorClass);
      }
    },
    to: 'nicknameError'
  },
  {
    when: {
      '@storePayment.nickname' : ['keyup', 'blur'],
      '@storePayment.save': ['change'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        return this._thenAddClassIfInvalid('storePayment.nickname', 'brec-form__input--error');
      }
    },
    to: 'storePayment.nickname'
  },
  {
    //******** Bank Routing Number *********
    /**
     * On keyup or blur on the bank routing number, validate the bank routing number and add the error
     * message if needed
     * @property feedback[2] (Bank routing number Error Message) {When/Then Feedback}
     */
    when: {
      '@achData.routingNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('achData.routingNumber'), {
          'required.failed' : 'field.enter',
          'error.digits.only' : 'ach.routingNumber.digitsOnly',
          'error.length' : 'ach.routingNumber.length.incorrect',
          'error.number.wrong' : 'ach.routingNumber.incorrect'
        }, this.format('ach.routingNumber'));
        var errorClass = this._thenAddClassIfInvalid('achData.routingNumber', 'brec-feedback--error');
        return _.extend(errorText, errorClass);
      }
    },
    to: 'routingNumberError'
  },
  {
  /**
   * On keyup or blur on the bank routing number, validate the bank routing number name and add the error
   * class to needed elements
   * @property feedback[3] (Bank routing number label) {When/Then Feedback}
   */
    when: {
      '@achData.routingNumber' : ['keyup', 'blur'],
    'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        return this._thenAddClassIfInvalid('achData.routingNumber', 'brec-form__input--error');
      }
    },
    to: 'achData.routingNumber'
  },
  {
    //******** Account Number *********
    /**
     * On keyup or blur on the account number, validate the account number and add the error
     * message if needed
     * @property feedback[4] (Account Number Error Message) {When/Then Feedback}
     */
    when: {
      '@achData.accountNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('achData.accountNumber'), {
          'required.failed' : 'field.enter',
          'error.digits.only' : 'ach.accountNumber.digitsOnly'
        }, this.format('ach.accountNumber'));
        var errorClass = this._thenAddClassIfInvalid('achData.accountNumber', 'brec-feedback--error');
        return _.extend(errorText, errorClass);
      }
    },
    to: 'accountNumberError'
  },
  {
    /**
     * On keyup or blur on the account number, validate the account number name and add the error
     * class to needed elements
     * @property feedback[5] (Account Number label) {When/Then Feedback}
     */
    when: {
      '@achData.accountNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        return this._thenAddClassIfInvalid('achData.accountNumber', 'brec-form__input--error');
      }
    },
    to: 'achData.accountNumber'
  },
  {
    //******** Account Number Confirm *********
    /**
     * On keyup or blur on the confirm account number, validate the confirm account number and add the error
     * message if needed
     * @property feedback[6] (Confirm Account Number Error Message) {When/Then Feedback}
     */
    when: {
      '@achData.accountNumber' : ['keyup', 'blur'],
      '@confirmAccountNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function(event) {
      if (this._shouldValidateConfirmAccount(event)) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('confirmAccountNumber'), {
          'required.failed' : 'ach.accountNumber.confirm.required',
          'ach.accountNumber.confirm.match' : 'ach.accountNumber.confirm.match.failed'
        }, this.format('ach.accountNumber.confirm'));
        var errorClass = this._thenAddClassIfInvalid('confirmAccountNumber', 'brec-feedback--error');
        return _.extend(errorText, errorClass);
      }
    },
    to: 'confirmAccountNumberError'
  },
  {
    /**
     * On keyup or blur on the confirm account number, validate the confirm account number name and add the error
     * class to needed elements
     * @property feedback[7] (Confirm Account Number label) {When/Then Feedback}
     */
    when: {
      '@achData.accountNumber' : ['keyup', 'blur'],
      '@confirmAccountNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function(event) {
      if (this._shouldValidateConfirmAccount(event)) {
        return this._thenAddClassIfInvalid('confirmAccountNumber', 'brec-form__input--error');
      }
    },
    to: 'confirmAccountNumber'
  },
  {
    //******** Driver's License Number *********
    /**
     * On keyup or blur on the driver's license number, validate the driver's license number and add the error
     * message if needed
     * @property feedback[8] (Driver's License Number Error Message) {When/Then Feedback}
     */
    when: {
      '@achData.driversLicenseNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('achData.driversLicenseNumber'), {
          'required.failed' : 'ach.driversLicense.number.required'
        });
        var errorClass = this._thenAddClassIfInvalid('achData.driversLicenseNumber', 'brec-feedback--error');
        return _.extend(errorText, errorClass);
      }
    },
    to: 'driversLicenseNumberError'
  },
  {
    /**
     * On keyup or blur on the driver's license number, validate the driver's license number name and add the error
     * class to needed elements
     * @property feedback[9] (Driver's License Number label) {When/Then Feedback}
     */
    when: {
      '@achData.driversLicenseNumber' : ['keyup', 'blur'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        return this._thenAddClassIfInvalid('achData.driversLicenseNumber', 'brec-form__input--error');
      }
    },
    to: 'achData.driversLicenseNumber'
  },
  {
    //******** Driver's License State *********
    /**
     * On keyup or blur on the driver's license state, validate the driver's license state and add the error
     * message if needed
     * @property feedback[4] (Driver's License State Error Message) {When/Then Feedback}
     */
    when: {
      '@achData.driversLicenseState' : ['change', 'click'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        var errorText = this._thenFormatFeedback(this.model.preValidate('achData.driversLicenseState'), {
          'required.failed' : 'ach.driversLicense.state.required'
        });
        var errorClass = this._thenAddClassIfInvalid('achData.driversLicenseState', 'brec-feedback--error');
        return _.extend(errorText, errorClass);
      }
    },
    to: 'driversLicenseStateError'
  },
  {
    /**
     * On keyup or blur on the driver's license state, validate the driver's license state name and add the error
     * class to needed elements
     * @property feedback[5] (Driver's License State label) {When/Then Feedback}
     */
    when: {
      '@achData.driversLicenseState' : ['change', 'click'],
      'on' : ['submit']
    },
    then: function() {
      if (this._shouldValidate()) {
        return this._thenAddClassIfInvalid('achData.driversLicenseState', 'brec-form__input--error');
      }
    },
    to: 'achData.driversLicenseState'
  }],

  /**
   * Initializes the form view responsible for handling ACH information.
   *
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient.
   * @override
   */
  initialize: function(options) {
    _.bindAll(this, '_defaultAccountOwnerName');
    this._patientVecnaId = options.patientVecnaId;
    this.listenTo(this.model, 'change:storePayment', this.render);
    this.listenTo(financialFeatureConfigModel, 'load-complete', this.render);
    financialFeatureConfigModel.loadOnce();

    this.listenTo(this.getBehavior('demographics'), 'fetched change:acceptedDemographics.contactInfo.name', this._defaultAccountOwnerName);
    this._defaultAccountOwnerName();
    this.on('submit', this._triggerPaymentDataReady);
  },

  /**
   * Prepares the view context for rendering.
   *
   * @method prepare
   * @return {object} context
   */
  prepare: function() {
    var context = TorsoFormView.prototype.prepare.apply(this);
    var isStoredPaymentMethodEnabled = financialFeatureConfigModel.isStoredPaymentMethodsEnabled(financialFeatureConfigModel.CONFIG_LEVEL.NORMAL);
    var isEnteringNewStoredPaymentOutsideOfPayment = this.model.get('isStoredPayment');
    context.selectSavePaymentMethod = this.model.get('storePayment.save') || isEnteringNewStoredPaymentOutsideOfPayment;
    context.canSelectSavePaymentMethod = isStoredPaymentMethodEnabled && !isEnteringNewStoredPaymentOutsideOfPayment;
    context.noStaticContentServer = applicationUtils.currentApplication.noStaticContentServer;
    return context;
  },

  /**
   * Trigger that the payment data is ready on the payment details model.
   *
   * @method _triggerPaymentDataReady
   * @private
   */
  _triggerPaymentDataReady: function() {
    this.model.trigger('paymentDataReady');
  },

  /**
   * @return {Boolean} true if the feedback validations should occur
   * @private
   * @method _shouldValidate
   */
  _shouldValidate: function() {
    return this.isAttached();
  },

  /**
   * @return {Boolean} true if the feedback validations should occur for confirm account
   * @param event {Event}
   * @private
   * @method _shouldValidateConfirmAccount
   */
  _shouldValidateConfirmAccount: function(event) {
    if (event) {
      var isAccountNumberTrigger = event.target && event.target.getAttribute('data-model') === 'achData.accountNumber';
      if (isAccountNumberTrigger) {
        return this._shouldValidate() && this.model.get('confirmAccountNumber');
      }
    }
    return this._shouldValidate();
  },

  /**
   * Default the account owner name to the current user if it has not already been set on the form model
   *
   * @method _defaultAccountOwnerName
   * @private
   */
  _defaultAccountOwnerName: function() {
    var name = this.getBehavior('demographics').data.get('acceptedDemographics.contactInfo.name');
    var accountOwnerName = name && name.givenName + ' ' + name.familyName;
    var shouldDefaultAccountOwnerName = accountOwnerName && !this.model.get('accountOwnerName');

    if (shouldDefaultAccountOwnerName) {
      this.model.set('accountOwnerName', accountOwnerName);
    }
  },

  /**
   * @method _activate
   * @override
   * @private
   */
  _activate: function() {
    this.model.clearAllPaymentMethodData();
  },

  /**
   * Clear feedback on deactivate so that when it is selected again it doesn't start with feedback shown.
   * @method _deactivate
   * @private
   */
  _deactivate: function() {
    this.feedbackCell.clear();
  }
});
